import React from 'react';
import { compose } from 'redux';
import classnames from 'classnames';
import uniqueId from 'lodash/uniqueId';
import { withTranslation, WithTranslation } from 'react-i18next';
import LoadingIndicator from '@wix/da-shared-react/pkg/LoadingIndicator';
import StandardMenu from '@wix/da-shared-react/pkg/Dropdown2/MenuPreset/StandardMenu';
import {
  withModuleConfig,
  WithModuleConfigProps,
} from '../../../_hoc/withModuleConfig';
import s from './SingleConfigFieldOptions.scss';

export interface Props {
  moduleId: number;
  paramName: string;
  title?: string;
  className?: string;

  close: () => void;

  moduleConfig?: {
    options?: {
      type: string;
      selected?: boolean;
    }[];
  };
  labels: {
    [key: string]: string;
  };
}

const defaultProps = {
  title: 'common.sortOrder',
};

const enhance = compose(withModuleConfig, withTranslation());
export class SingleConfigFieldOptions extends React.Component<
  Props & WithTranslation & WithModuleConfigProps
> {
  readonly id = uniqueId('widget-edit-sortby');
  static defaultProps = defaultProps;

  render() {
    const { paramName, moduleConfig, labels, title, t } = this.props;
    if (!moduleConfig) {
      return <LoadingIndicator />;
    }
    const { [paramName]: options } = moduleConfig.options;
    const items = options.map(({ type, value = type, selected }) => ({
      label: labels?.[value] ? t(labels[value]) : value,
      value,
      selected,
    }));

    return (
      <StandardMenu
        id={this.id}
        className={classnames(s['menu'], this.props.className)}
        itemClassName={s['menu-item']}
        label={t!(title!)}
        items={items}
        onSelect={this.handleChange}
        withCardWrapper={false}
      />
    );
  }
  handleChange = (value, label) => {
    const { paramName, saveModuleConfig, close } = this.props;
    const payload = {
      [paramName]: value,
    };
    saveModuleConfig && saveModuleConfig(payload);
    close && close();
  };
}

export default enhance(SingleConfigFieldOptions) as React.ComponentType<Props>;
